import { env } from '@mcdougald/env';

import i18nConfig from '../../i18n.config.json';

export const isProduction = env.NODE_ENV === 'production';

const vercelUrl = env.NEXT_PUBLIC_URL ?? false;

const prodUrl = isProduction ? 'https://trev.fyi' : 'http://localhost:3000';

export const PROD_OR_LOCAL_URL = isProduction
  ? 'https://trev.fyi'
  : 'http://localhost:3000';

export const SITE_URL = vercelUrl ? env.VERCEL_URL : prodUrl;

export const GITHUB_USERNAME = 'mcdougald';

export const SITE_NAME = 'Trevor McDougald';
export const SHARE_REFERENCE_GOOGLE_FORM_LINK =
  'https://forms.gle/w6xaQDkZCVtXeT59A';
export const CONTACT_ME_GOOGLE_FORM_LINK =
  'https://forms.gle/RgKpFUyziqo1t9du5';

export const SITE_GITHUB_URL = 'https://github.com/mcdougald';
export const SITE_FACEBOOK_URL = 'https://www.facebook.com/mcdougald';
export const SITE_INSTAGRAM_URL = 'https://www.instagram.com/mcdougald';
export const SITE_X_URL = 'https://x.com/mcdougald';
export const SITE_YOUTUBE_URL = 'https://www.youtube.com/@mcdougald';
export const SITE_LINKEDIN_URL = 'https://www.linkedin.com/in/trevormcdougald/';

// Sorted list of supported locales codes, defined in `i18n.config.json`
const BUILD_LOCALES = process.env.BUILD_LOCALES;
export const LOCALES_CODES = BUILD_LOCALES
  ? BUILD_LOCALES.split(',')
  : i18nConfig.map(({ code }) => code);

export type Lang =
  | 'en'
  | 'am'
  | 'ar'
  | 'az'
  | 'be'
  | 'bg'
  | 'bn'
  | 'bs'
  | 'ca'
  | 'cs'
  | 'da'
  | 'de'
  | 'el'
  | 'es'
  | 'fa'
  | 'fi'
  | 'fil'
  | 'fr'
  | 'gl'
  | 'gu'
  | 'ha'
  | 'he'
  | 'hi'
  | 'hr'
  | 'hu'
  | 'hy-am'
  | 'id'
  | 'ig'
  | 'it'
  | 'ja'
  | 'ka'
  | 'kk'
  | 'km'
  | 'kn'
  | 'ko'
  | 'lt'
  | 'ml'
  | 'mr'
  | 'ms'
  | 'nb'
  | 'ne-np'
  | 'nl'
  | 'pcm'
  | 'pl'
  | 'pt-br'
  | 'pt'
  | 'ro'
  | 'ru'
  | 'se'
  | 'sk'
  | 'sl'
  | 'sn'
  | 'sr'
  | 'sw'
  | 'ta'
  | 'te'
  | 'th'
  | 'tk'
  | 'tl'
  | 'tr'
  | 'tw'
  | 'uk'
  | 'ur'
  | 'uz'
  | 'vi'
  | 'yo'
  | 'zh-tw'
  | 'zh';

export type Direction = 'rtl' | 'ltr' | 'auto';

export type I18nLocale = {
  code: Lang;
  crowdinCode: string;
  name: string;
  localName: string;
  langDir: Direction;
  dateFormat: string;
};
